import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const problems = ['Llegás a la cancha sin un plan claro y terminás improvisando el entrenamiento', 'Tus jugadores repiten los mismos errores técnicos sesión tras sesión', 'No sabés cómo progresar los ejercicios según la edad o el nivel del grupo', 'Te falta una estructura para planificar la temporada y medir avances', 'Te cuesta comunicarte con los padres y gestionar al equipo'];
export function Problems() {
  return <section className="w-full bg-white py-12 md:py-16 px-4" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-84">
          <p className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-85">
            Probablemente te pasa alguna de estas cosas 😬
          </p>
          <div className="space-y-4" data-id="element-86">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-3 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg" data-id="element-87">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-88" />
                <p className="text-gray-800 font-medium" data-id="element-89">{problem}</p>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-6" data-id="element-90">
          Este sistema está pensado para resolver ese tipo de problemas:
        </motion.p>
      </div>
    </section>;
}